/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthStrictHttpResponse } from '../../auth-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchRequestModel } from '../../models/search-request-model';
import { UserSearchResultModelSearchResultModel } from '../../models/user-search-result-model-search-result-model';

export interface UserSearchUserPost$Params {
      body?: SearchRequestModel
}

export function userSearchUserPost(http: HttpClient, rootUrl: string, params?: UserSearchUserPost$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<UserSearchResultModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, userSearchUserPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AuthStrictHttpResponse<UserSearchResultModelSearchResultModel>;
    })
  );
}

userSearchUserPost.PATH = '/User/SearchUser';
